import { ParsedLocale } from 'lib/constants/localization'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { getCountryFlagIcon } from 'lib/features/country'
import { languageDomains } from 'lib/constants/language'
import { languageToCountryCode } from 'lib/formatting/language'
import { Body2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import { returnCountrySwitcherLabelByContentLanguage } from 'lib/constants/localizedCountryLabels'
import { countryDomains } from 'lib/constants/country'

const Container = styled.div`
    width: 100%;
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr 1fr;
    .option {
        cursor: pointer;
        display: flex;
        height: 100%;
        gap: 10px;
        justify-content: start;
        align-items: center;
        padding-left: 25px;
        &:hover {
            p {
                color: ${theme.colors.deepSeaBlue};
            }
        }
        svg {
            scale: 0.7;
            position: relative;
            bottom: 0px;
        }
    }
`

const StyledLink = styled.a`
    text-decoration: none;
    color: inherit;
`

interface Props {
    parsedLocale: ParsedLocale
    onChanged: () => void
}

const CountrySwitcher = ({ parsedLocale, onChanged }: Props) => {
    const router = useRouter()
    const { asPath } = router

    if (!parsedLocale) return null

    const countryOptions = Object.values(languageDomains).map((v) => {
        const countryCode = languageToCountryCode(v)
        const domain = Object.entries(countryDomains).find(([_, code]) => code === countryCode)?.[0] || ''
        return {
            data: v,
            label: returnCountrySwitcherLabelByContentLanguage({ contentLanguageCode: v } as ParsedLocale),
            countryCode,
            domain: domain ? `https://${domain}${asPath}` : '',
        }
    })

    const handleUpdateLocale = (e: React.MouseEvent, data: string) => {
        router.push(asPath, asPath, { locale: data })
    }

    return (
        <Container>
            {countryOptions.map((option) => (
                <StyledLink
                    href={option.domain || '#'}
                    onClick={(e) => handleUpdateLocale(e, option.data)}
                    key={`country-${option.label}`}
                >
                    <div className="option">
                        {getCountryFlagIcon(option.countryCode)}

                        <Body2 key={option.label} color={theme.colors.body1Black}>
                            {option.label}
                        </Body2>
                    </div>
                </StyledLink>
            ))}
        </Container>
    )
}

export default CountrySwitcher
